import React, {useEffect, useRef} from 'react';
import styled from 'styled-components';
import {Col, Container, Row} from 'react-bootstrap';
import {hover, text} from '../../styles/globalStyleVars';
import gsap from 'gsap';
import {ImgLazyLoad} from '../nzuac-image/ImgLazyLoad';
import reactHtmlParser from 'react-html-parser';
import VideoDetails from './VideoDetails';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, EffectFade, Navigation, Pagination} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import SocialShare from '../nzuac-social-icons/SocialShare';
import {useLocation} from 'react-router-dom';
import Table from '../../pages/university/components/Table';

const Details = ({data}) => {

  const sectionSingle = useRef();
  const detailsRef = useRef();
  const location = useLocation();
  useEffect(() => {
    // let details = document.querySelector('.details-wrapper ')

    if (window?.innerWidth > 1700 && detailsRef?.current) {
      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: sectionSingle?.current,
          start: 'top top+=180px',
          pinnedContainer: sectionSingle?.current,
          ease: 'elastic',
          id: 'whois',
          end: '+='+(document.querySelector('.details-wrapper').clientHeight - 400),
          pinType: 'transform',
          pin: true,
          pinSpacing: false,
          toggleActions: 'play none none reverse',


        }
      });

      return () => {
        timeline.kill();
      };
    }
    if (window?.innerWidth > 992 && detailsRef?.current) {
      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: sectionSingle?.current,
          start: 'top top+=180px',
          pinnedContainer: sectionSingle?.current,
          ease: 'elastic',
          id: 'whois',
          end: '+='+(document.querySelector('.details-wrapper').clientHeight - 300),
          pinType: 'transform',
          pin: true,
          pinSpacing: false,
          toggleActions: 'play none none reverse',


        }
      });

      return () => {
        timeline.kill();
      };
    }


  }, [data, location?.pathname]);


  var date = new Date(data?.data?.date);

  // Extract day, month, and year
  var day = date.getDate();
  var month = date.toLocaleString('default', {month: 'long'});
  var year = date.getFullYear();
  var fullDate = day + ' ' + month + ' ' + year;

  const banner = data?.images?.list?.find(f => f?.banner === 'on');


  return (
    <StyledDetails className="details-wrapper">

      <Container>
        <Row ref={detailsRef}>
          <Col  md={3} className={'social-pin-wrapper'}>
            <div ref={sectionSingle} className="social-pin-wrapper">
              {
                window?.innerWidth > 767 ?
                  <div className="social-wrapper-main">
                    <SocialShare direction/>
                  </div>
                  :
                  ''
              }
            </div>

          </Col>
          <Col md={{span: 9}}>
            <div className="intro">
              <div className="intro-left">
                <h1 className={'split-up'}>{data?.data?.title ? reactHtmlParser(data?.data?.title) : ''}</h1>
              </div>
            </div>
            <div className="breadcump">
              <p className={'split-up'}>{data?.data?.category_id === 1 ? 'News' : data?.data?.category_id === 2 ? 'Blog' : data?.data?.category_id === 3 ? 'Events' : ''}</p>
              <p className={'split-up'}>{fullDate}</p>
            </div>

            {
              banner?.full_path &&
                            <div className="banner-for-news">
                              <ImgLazyLoad alt={data?.data?.title} src={banner?.full_path}/>
                            </div>
            }




            {data?.posts?.list?.map((item, index) => {


              if (item?.data?.template === 'Table') {
                return (
                  <React.Fragment className={'overview'} key={index}>
                    <Table data={item}/>
                  </React.Fragment>
                );
              } else if (item?.data?.template === 'details_video') {

                return (
                  <React.Fragment key={index}>

                    {
                      item?.data?.description &&
                          <div className="detail-description mb-bottom">
                            {
                              item?.data?.description &&
                                reactHtmlParser(item?.data?.description)
                            }

                          </div>

                    }
                    <VideoDetails image={item?.images?.[0]?.full_path} link={item?.images?.[0]?.short_title}/>
                    {
                      item?.images?.[0]?.short_desc && <p className={'caption'}>{reactHtmlParser(item?.images?.[0]?.short_desc)}</p>
                    }
                  </React.Fragment>
                );
              } else if (item?.data?.template === 'details_list_counter') {

                return (
                  <React.Fragment key={index}>
                    <div className="detail-description">
                      {
                        item?.data?.description &&
                            reactHtmlParser(item?.data?.description)

                      }
                    </div>
                  </React.Fragment>
                );
              } else if (item?.data?.template === 'details_slider') {

                return (
                  <React.Fragment key={index}>
                    {
                      item?.images?.length > 0 &&
                          <div className="image-gallery-slider">
                            <Swiper
                              Swiper
                              modules={[Autoplay, Pagination, Navigation, EffectFade]}
                              slidesPerView={1}
                              speed={1500}
                              spaceBetween={50}
                              draggable={true}
                              navigation={{
                                prevEl: '#details-prev',
                                nextEl: '#details-next'
                              }}
                              loop={false}
                            >
                              {
                                item?.images?.length > 0 &&
                                  item?.images?.map((item, index) => {
                                    return (
                                      <SwiperSlide key={index}>
                                        <div className="img-group-caption">
                                          <div className="img-wrapper-big">
                                            <ImgLazyLoad alt={item?.short_desc} src={item?.full_path}/>
                                          </div>
                                          <p>{reactHtmlParser(item?.short_desc)}</p>
                                        </div>
                                      </SwiperSlide>
                                    );
                                  })
                              }


                            </Swiper>

                            {

                              item?.images?.length > 0 &&
                                <div className="navigation">
                                  <div className="blog-button">
                                    <div className="slider-nav">

                                      <ul>
                                        <li id={'details-prev'}>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="11.207" height="11.414" viewBox="0 0 11.207 11.414">
                                            <g id="Arrow" transform="translate(0.707 0.707)">
                                              <g id="Group_23756" data-name="Group 23756">
                                                <line id="Line_3910" data-name="Line 3910" x1="5" y2="5" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="1"/>
                                                <line id="Line_3911" data-name="Line 3911" x2="5" y2="5" transform="translate(0 5)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="1"/>
                                              </g>
                                              <line id="Line_3912" data-name="Line 3912" x1="10" transform="translate(0 5)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="1"/>
                                            </g>
                                          </svg>


                                        </li>
                                        <li id={'details-next'}>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="11.207" height="11.414" viewBox="0 0 11.207 11.414">
                                            <g id="Arrow" transform="translate(-648 -1595.793)">
                                              <g id="Group_4823" data-name="Group 4823" transform="translate(653.5 1596.5)">
                                                <line id="Line_9" data-name="Line 9" x2="5" y2="5" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="1"/>
                                                <line id="Line_10" data-name="Line 10" x1="5" y2="5" transform="translate(0 5)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="1"/>
                                              </g>
                                              <line id="Line_11" data-name="Line 11" x2="10" transform="translate(648.5 1601.5)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="1"/>
                                            </g>
                                          </svg>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                            }


                          </div>
                    }


                  </React.Fragment>
                );
              } else {
                return null; // If the template doesn't match any case, render nothing
              }

            })}







          </Col>
        </Row>
      </Container>
    </StyledDetails>
  )
  ;
};

const StyledDetails = styled.section`
  padding: 100px 0 0;
  background: #F1F0EE;
  position: relative;

  .top-go-back-button {
    top: 0;
    position: absolute;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    @media(max-width: 992px) and (min-width: 768px){
      top: -10px;
    }
    li {
      flex: 0 0 50%;
      max-width: 50%;
      padding: 20px 15px;
      display: flex;
      cursor: pointer;

      p {
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
      }

      &:first-child {
        background: white;

        svg {
          margin-right: 20px;
        }
      }

      &:last-child {
        justify-content: flex-end;

        svg {
          margin-left: 20px;
        }

        p {
          color: white
        }

        background: ${hover};
      }
    }
  }


  .social-wrapper-main {
    padding-right: 40px;
  }

  .small-box-cta {
    margin-top: 20px;
  }

  //introduction

  .breadcump {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 20px;

    p {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;

      &:first-child {
        color: ${hover};
      }

      &:last-child {
        color: ${text};
      }
    }
  }

  .banner-for-news {
    position: relative;
    padding-top: calc(480 / 870 * 100%);
    margin-bottom: 60px;
  }

  .intro {
    margin-bottom: 20px;
    display: flex;


    .intro-left {
      flex: 0 0 100%;
      max-width: 100%;

      h1 {
        font-size: 40px;
        font-weight: 500;
        line-height: 44px;
        color: ${text};
        margin-top: 30px;
      }
    }

    .intro-right {
      flex: 0 0 20%;
      max-width: 20%;

      .box-wrapper {
        position: relative;
        padding-top: calc(130 / 170 * 100%);
        background: ${hover};

        .content {
          position: absolute;
          inset: 0;
          height: 100%;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 15px;

          p {
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            color: rgba(255, 255, 255, 0.5);

            &.ranking {
              color: rgba(255, 255, 255, 1);
              font-size: 40px;
              font-weight: 600;
              line-height: 44px;
            }
          }
        }
      }
    }
  }


  //overview

  .overview {
    padding-bottom: 30px;
    border-bottom: 1px solid #040504;
    margin-bottom: 30px;

    h3 {
      font-size: 28px;
      font-weight: 500;
      line-height: 32px;
      margin-bottom: 20px;
    }

    h2 {
      font-size: 28px;
      font-weight: 500;
      line-height: 32px;
      margin-bottom: 20px;
      color: ${hover};
    }

    h4 {
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 20px;
    }


    .nzuac-list {
      li {
        font-weight: 400 !important;
        border-bottom: 1px solid rgba(4, 5, 4, 0.2);
      }
    }

    .caption {
      font-weight: 500;
      margin-top: 20px;
    }

    h5 {
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 20px;
      color: ${text};
    }

    p {
      color: ${text};
      margin-bottom: 60px;

      a {
        color: ${hover};
        font-weight: 500;
      }
    }

    table {
      tr {
        border-bottom: 1px solid rgba(4, 5, 4, 0.2);

        &:first-child {
          border-bottom: 1px solid #040504 !important;
        }

        &:last-child {
          border-bottom: none !important;
        }
      }

      td {
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
      }

      th {
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;

      }
    }
  }

  blockquote {
    margin-bottom: 60px;
  }

  .video-modal {
    margin-bottom: 0 !important;
  }

  .caption {
    font-weight: 500;
    margin-top: 20px;
    margin-bottom: 60px;
  }

  //banner 

  .banner {
    .campus {
      margin-bottom: 30px;
      display: flex;

      .campus-single {
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
        margin-right: 30px;

        &:last-child {
          margin-right: 0;
        }

        h5 {
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          color: rgba(4, 5, 4, 0.5);
          margin-bottom: 10px;
        }

        p {
          color: ${text};
          font-size: 20px;
          font-weight: 500;
          line-height: 24px;
          margin: 0;
        }
      }
    }

    .banner-wrapper {
      position: relative;
      padding-top: calc(480 / 870 * 100%);
    }
  }


  .middle-description {
    h2 {
      font-size: 28px;
      font-weight: 500;
      line-height: 32px;
      margin-bottom: 20px;
      color: ${hover};
    }

    h4 {
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 20px;
      color: ${hover};
    }

    p {
      color: ${text};
      margin-bottom: 60px;

      a {
        color: ${hover};
        font-weight: 500;
      }
    }
  }

  .bottom-description {
    border-bottom: 1px solid #040504;
    padding-bottom: 60px;

    h4 {
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 20px;
      color: ${hover};
    }

    h3 {
      font-size: 28px;
      font-weight: 500;
      line-height: 32px;
      margin-bottom: 20px;
    }

    p {
      color: ${text};
      margin-bottom: 60px;

      a {
        color: ${hover};
        font-weight: 500;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .img-group-multiple {
    margin-bottom: 40px;

    .img-wrapper-big {
      position: relative;
      padding-top: calc(59.7701%);
      margin-bottom: 30px;

      .global-image {
        position: absolute;
        height: 100%;
        width: 100%;
        inset: 0px;
        margin: 0px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          inset: 0px;
        }
      }
    }

    .img-wrapper-small {
      position: relative;
      padding-top: calc(59.5238%);

      .global-image {
        position: absolute;
        height: 100%;
        width: 100%;
        inset: 0px;
        margin: 0px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          inset: 0px;
        }
      }

    }

    @media (max-width: 767px) {
      .col-md-6 {
        &:last-child {
          margin-top: 30px;
        }
      }
    }
  }

  //course list

  .course-list-wrapper {
    margin-top: 30px;
    padding-bottom: 60px;
    border-bottom: 1px solid #040504;
    margin-bottom: 60px;

    h2 {
      font-size: 28px;
      font-weight: 500;
      line-height: 32px;
      color: ${hover};
      margin-bottom: 30px;
    }

    .course-list {

      display: flex;
      gap: 30px;
      flex-flow: wrap;
    }

    .course-single {
      flex: 0 0 calc(33.3333% - 30px);
      max-width: calc(33.3333% - 30px);
    }
  }

  //description

  .mb-bottom {
    margin-bottom: 60px;
  }

  .detail-description {


    h3 {
      font-size: 28px;
      font-weight: 500;
      line-height: 32px;
      margin-bottom: 20px;
    }

    h2 {
      font-size: 28px;
      font-weight: 500;
      line-height: 32px;
      margin-bottom: 20px;
      color: ${hover};
    }

    h4 {
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 20px;
    }


    .nzuac-list {
      li {
        font-weight: 400 !important;
        border-bottom: 1px solid rgba(4, 5, 4, 0.2);
      }
    }

    .caption {
      font-weight: 500;
      margin-top: 20px;
    }

    h5 {
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 20px;
      color: ${text};
    }

    p {
      color: ${text};
      margin-bottom: 60px;

      a {
        color: ${hover};
        font-weight: 500;
      }
    }

    table {
      tr {
        border-bottom: 1px solid rgba(4, 5, 4, 0.2);

        &:first-child {
          border-bottom: 1px solid #040504 !important;
        }

        &:last-child {
          border-bottom: none !important;
        }
      }

      td {
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
      }

      th {
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;

      }
    }

    .nzuac-list-count {
      margin-bottom: 20px;

      span {
        display: block;
        font-weight: 500;
      }
    }




    h2 {
      font-size: 28px;
      font-weight: 500;
      line-height: 32px;
      color: ${hover};
      margin-bottom: 20px;
    }

    table {
      gap: 20px;
      margin-bottom: 60px;

      th {
        font-size: 16px; /* 20px / 15px = 1.3333rem */
        font-weight: 400;
        line-height: 20px; /* 28px / 15px = 1.8667rem */
        color: ${text};
        border-top: none !important;
      }

      tr {
        border-bottom: 1px solid rgba(20, 38, 55, 0.2);
        justify-content: flex-start;
        padding: 20px 0;
        display: flex;
        flex-wrap: wrap;
        gap: 30px;
        font-size: 16px; /* 20px / 15px = 1.3333rem */
        font-weight: 400;
        line-height: 20px; /* 28px / 15px = 1.8667rem */

        &:first-child {
          border-bottom: 1px solid rgba(4, 5, 4, 0.2);
          padding-top: 0;
        }

        &:last-child {
          border-bottom: none;
        }

        th {
          max-width: calc(50% - 30px);
          flex: 0 0 calc(50% - 30px);
        }

        td {
          max-width: calc(50% - 30px);
          flex: 0 0 calc(50% - 30px);
        }
      }
    }

    ul {
      margin-top: 0;
      margin-bottom: 60px;

      li {
        border-bottom: 1px solid rgba(4, 5, 4, 0.2);
        font-size: 16px;
        font-weight: 400;

        strong {
          font-weight: 500;
        }
      }
    }

  }


  .image-gallery-slider {
    position: relative;
    margin-bottom: 60px;

    .navigation {
      position: absolute;
      bottom: -35px;
      right: 0;
    }

    .img-wrapper-big {
      padding-top: calc(570 / 870 * 100%);
      position: relative;
    }

    .swiper-slide-active {
      p {
        transition-delay: 0.7s;
        opacity: 1;
      }
    }

    p {
      opacity: 0;
      transition: 0.7s all cubic-bezier(0.54, 0.32, 0.05, 0.96);
      max-width: 70%;
      margin-top: 35px;
      font-weight: 500;
    }
  }


  //responsive
  @media (max-width: 767px) {
    .intro {
      display: flex;
      align-items: flex-start;
      position: relative;

      .intro-left {
        flex: 0 0 100%;
        max-width: 100%;
      }

      .intro-right {
        flex: unset;
        max-width: unset;
        position: absolute;
        right: 0;
        top: 0;


        .box-wrapper {
          position: unset;
          padding-top: unset;
          background: transparent;

          .global-image {
            display: none;
          }

          .content {
            position: unset;
            inset: unset;
            padding: 0;

            p {
              color: #888888;

              &.ranking {
                color: ${hover};
              }
            }
          }
        }
      }
    }

    .banner {
      .campus {
        flex-direction: column;

        .campus-single {
          flex: 0 0 100%;
          max-width: 100%;
          margin-bottom: 30px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .course-list-wrapper {
      course-box {
        padding-top: calc(120 / 345 * 100%);
      }

      .course-single {
        max-width: 100%;
        flex: 0 0 100%;
      }
    }
  }
`;

export default React.memo(Details);




